import { render, staticRenderFns } from "./CustomerAddressInput.vue?vue&type=template&id=39a563b6&scoped=true"
import script from "./CustomerAddressInput.vue?vue&type=script&lang=js"
export * from "./CustomerAddressInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a563b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a563b6')) {
      api.createRecord('39a563b6', component.options)
    } else {
      api.reload('39a563b6', component.options)
    }
    module.hot.accept("./CustomerAddressInput.vue?vue&type=template&id=39a563b6&scoped=true", function () {
      api.rerender('39a563b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteHeader/CustomerAddressInput.vue"
export default component.exports